// extracted by mini-css-extract-plugin
export default {"mainContainer":"style_mainContainer__uBa4n","backBtn":"style_backBtn__I-bRn","heading":"style_heading__nP89E"};